/**
 * API Configuration
 * Centralized configuration for API endpoints
 * Updated: 2025-10-07 - Unified all endpoints to use relative paths
 * NOTE: Axios baseURL is set to '/api/v1' in api.ts, so all paths here are relative
 */

// API endpoints - NOTE: Using relative paths (axios baseURL handles /api/v1 prefix)
export const API_ENDPOINTS = {
  // Jurisprudence endpoints
  jurisprudence: {
    search: '/jurisprudence/search',
    getCase: (id: string) => `/jurisprudence/case/${id}`,
  },

  // Laws endpoints
  laws: {
    search: '/laws/zakony/search',
    getDetail: (lawNumber: string) => {
      // lawNumber format: "89/2012" -> "/laws/zakony/89/2012"
      const parts = lawNumber.split('/');
      return `/laws/zakony/${parts[0]}/${parts[1]}`;
    },
    getReferences: (lawNumber: string) => {
      const parts = lawNumber.split('/');
      return `/laws/zakony/${parts[0]}/${parts[1]}/references`;
    },
  },

  // Contract endpoints
  contracts: {
    analyze: '/contracts/analyze',
    generate: '/contracts/generate',
  },

  // Consultation endpoints
  consultation: {
    analyze: '/consultation/analyze',
  },

  // Auth endpoints
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    refresh: '/auth/refresh',
  },

  // Stripe subscriptions
  subscriptions: {
    checkout: '/subscriptions/checkout',
    creditsCheckout: '/subscriptions/credits/checkout',
    portal: '/subscriptions/portal',
    verifySession: (sessionId: string) => `/subscriptions/verify-session/${sessionId}`,
    status: '/subscriptions/status',
    creditHistory: '/subscriptions/credits/history',
    creditBalance: '/subscriptions/credits/balance',
    invoices: '/subscriptions/invoices',
  },
};

export default API_ENDPOINTS;
